export default __webpack_public_path__ + "static/media/js.2f5c1d5f.svg";